<div class="azure-map" #azureMap></div>
